import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Button} from "primereact/button";

const MainLayout = ({children, header}) => {
	const navigate = useNavigate();
	const [sidebarExpanded, setSidebarExpanded] = useState(() => {
		const savedState = localStorage.getItem("sidebarExpanded");
		return savedState ? JSON.parse(savedState) : false;
	});

	useEffect(() => {
		localStorage.setItem("sidebarExpanded", JSON.stringify(sidebarExpanded));
	}, [sidebarExpanded]);

	const handleLogout = () => {
		sessionStorage.removeItem("token");
		sessionStorage.removeItem("role");
		sessionStorage.removeItem("seh_id");
		navigate("/login");
	};

	const menuItems = [
		{
			label: "Серия рақамлар",
			icon: "pi pi-tag",
			items: [
				{
					label: "Янги серия рақам олиш",
					icon: "pi pi-plus-circle",
					command: () => navigate("/generation"),
					roles: ["admin", "seh_brigadir"],
				},
				{
					label: "Серия рақамлар",
					icon: "pi pi-barcode",
					command: () => navigate("/generated"),
					roles: ["admin", "seh_brigadir"],
				},
			],
		},
		{
			label: "Накладнойлар",
			icon: "pi pi-file",
			items: [
				{
					label: "Накладной яратиш",
					icon: "pi pi-plus-circle",
					command: () => {
						localStorage.removeItem(`invoice-edit`);
						navigate("/invoice-creation");
					},
					roles: ["admin", "seh_brigadir"],
				},
				{
					label: "Накладнойлар",
					icon: "pi pi-receipt",
					command: () => navigate("/invoice"),
					roles: ["admin", "seh_brigadir"],
				},
				{
					label: "Тарих",
					icon: "pi pi-history",
					command: () => navigate("/invoice-history"),
					roles: ["admin", "seh_brigadir"],
				},
			],
		},
		{
			label: "Склад",
			icon: "pi pi-box",
			items: [
				{
					label: "Қабул қилиш",
					icon: "pi pi-plus-circle",
					command: () => navigate("/recieve"),
					roles: ["admin", "sklad_rahbari"],
				},
				{
					label: "Остаток",
					icon: "pi pi-receipt",
					command: () => navigate("/balance"),
					roles: ["admin", "sklad_rahbari"],
				},
				{
					label: "Отгрузкалар",
					icon: "pi pi-list",
					command: () => navigate("/release"),
					roles: ["admin", "sklad_rahbari", "security"],
				},
				{
					label: "Мижозга отгрузка",
					icon: "pi pi-user-plus",
					command: () => navigate("/customer", {state: {client: true}}),
					roles: ["admin", "sklad_rahbari", "security"],
				},
				{
					label: "Магазинга отгрузка",
					icon: "pi pi-shopping-cart",
					command: () => navigate("/store", {state: {shop: true}}),
					roles: ["admin", "sklad_rahbari", "security"],
				},
				{
					label: "Блоклар",
					icon: "pi pi-th-large",
					command: () => navigate("/blocks"),
					roles: ["admin", "sklad_rahbari", "security"],
				},
			],
		},
	];

	const userRole = sessionStorage.getItem("role");
	const filteredMenuItems = menuItems
		.map((route) => ({
			...route,
			items: route.items.filter((item) => item.roles.includes(userRole)),
		}))
		.filter((route) => route.items.length > 0);

	const renderMenuItems = () => {
		if (sidebarExpanded) {
			return (
				<div className="w-full text-white bg-blue custom-menu">
					{filteredMenuItems.map((category, categoryIndex) => (
						<div key={categoryIndex} className="mb-2 menu-category">
							<div className="flex items-center p-2 font-bold">
								<i className={`${category.icon} mr-2`}></i>
								<span>{category.label}</span>
							</div>
							<div className="menu-items">
								{category.items.map((item, itemIndex) => (
									<div
										key={itemIndex}
										className="flex items-center p-2 pl-6 cursor-pointer hover:bg-blue-700"
										onClick={item.command}>
										<i className={`${item.icon} mr-2`}></i>
										<span>{item.label}</span>
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			);
		} else {
			return (
				<div className="flex flex-col items-center mt-3 bg-blue">
					{filteredMenuItems.map((item) =>
						item.items.map((value, index) => (
							<div
								key={index}
								className="flex flex-col items-center mb-6 cursor-pointer"
								onClick={value.command}
								title={value.label}>
								<i className={`${value.icon} text-lg`}></i>
							</div>
						))
					)}
				</div>
			);
		}
	};

	const sidebarWidth = sidebarExpanded ? "w-64" : "w-16";
	const contentMargin = sidebarExpanded ? "ml-64" : "ml-16";

	return (
		<div className="flex font-hyundai">
			<div
				className={`${sidebarWidth} text-white flex flex-col h-screen fixed left-0 top-0 transition-all duration-300 z-10`}>
				<div className="flex items-end justify-end p-2 pt-4 pb-0 pr-3 bg-blue">
					<Button
						icon={
							sidebarExpanded ? "pi pi-chevron-left" : "pi pi-chevron-right"
						}
						className="p-2 text-white border-none outline-none ring-0 focus:ring-0 focus:outline-none active:outline-none !bg-blue"
						onClick={() => setSidebarExpanded(!sidebarExpanded)}
					/>
				</div>
				<div className="flex-1 overflow-y-auto bg-blue">
					{renderMenuItems()}
				</div>
			</div>

			<div
				className={`flex-1 ${contentMargin} transition-all duration-300`}
				style={{
					width: `calc(100vw - ${sidebarExpanded ? "500px" : "128px"})`,
				}}>
				<div className="flex items-center p-4 text-center text-white bg-blue">
					<h1 className="w-full text-3xl font-bold max-sm:text-2xl max-[460px]:text-xl px-3">
						{header}
					</h1>
					<Button
						icon={`pi pi-sign-out`}
						onClick={handleLogout}
						className="scale-125 ring-0 focus:ring-0 focus:outline-none active:outline-none"
					/>
				</div>
				<div className="px-4 pt-8">{children}</div>
			</div>
		</div>
	);
};

export default MainLayout;
